import appStore from "store";
import api from "./api";
import { PAGINATION } from "./constants";

const store = {
  namespaced: true,
  state: {
    list: [],
    totalCount: 0,
    pagination: PAGINATION,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload.list ? payload.list.slice() : [];
      state.totalCount = payload.totalCount || 0;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
  },
  actions: {
    list({ commit, state }, query = {}) {
      const page = query.page || state.pagination.page || PAGINATION.page;
      const size = query.size || state.pagination.size || PAGINATION.size;
      commit("setPagination", { page, size });
      api.getList(query).then((res) => {
        if (res.code === 0) {
          commit("setList", res.data || {});
        }
      });
    },
  },
};

appStore.registerModule("userRiskPanel", store);

